import { Button } from '@/components/ui/atoms/button'
import Whatsapp from '@/components/ui/atoms/whatsapp'
import { cn } from '@/lib/client'
import { Users } from 'lucide-react'

export default function ExclusiveGroupBanner({
  className,
  link,
  title,
  description,
  button,
}: {
  className?: string
  link: string
  title: string
  description: string
  button: string
}) {
  return (
    <div className={cn('my-8', className)}>
      <div className="relative isolate overflow-hidden bg-zinc-900 py-6 px-8 rounded-xl bg-no-repeat bg-cover bg-right">
        <div className="flex flex-col text-center items-center lg:flex-row lg:text-left lg:items-center">
          <Whatsapp width="300" height="200" viewBox="0 0 32 33" fill="#fff" />
          <div className="mt-6 space-y-3 lg:mt-0 lg:items-center basis-9/12">
            <h3 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
              {title}
            </h3>
            <p className="mt-4 text-md leading-6 text-zinc-50">{description}</p>
            <Button variant={'default'} asChild className="cursor-pointer">
              <a
                href={link}
                target="_blank"
                aria-label="Assinaturas"
                rel="noreferrer"
              >
                <Users className="mr-1 h-4 w-4" />
                {button}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
